import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
const rotatingWords = ['Reclutamiento', 'Selección', 'Búsqueda de Talento', 'Consultoría de RR.HH.'];
export function Hero() {
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentWordIndex(prev => (prev + 1) % rotatingWords.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);
  return <section className="relative min-h-screen flex items-center overflow-hidden" data-id="element-121">
      {/* Clean light background */}
      <div className="absolute inset-0 bg-gradient-to-br from-slate-50 via-gray-50 to-slate-100" data-id="element-122"></div>

      <div className="max-w-7xl mx-auto w-full px-6 py-20" data-id="element-123">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-124">
          {/* Left side - Content */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="relative z-10" data-id="element-125">
            <motion.h1 initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            delay: 0.2,
            ease: 'easeOut'
          }} className="text-4xl md:text-5xl lg:text-6xl font-semibold text-slate-700 mb-6 leading-tight uppercase tracking-wide" style={{
            fontFamily: 'Outfit, sans-serif',
            letterSpacing: '0.05em'
          }} data-id="element-126">
              Acompañamos Personas. Impulsamos Equipos.
            </motion.h1>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            delay: 0.3,
            ease: 'easeOut'
          }} className="text-2xl md:text-3xl font-bold text-purple-500 mb-8 h-12" style={{
            fontFamily: 'Outfit, sans-serif'
          }} data-id="element-127">
              <AnimatePresence mode="wait" data-id="element-128">
                <motion.span key={currentWordIndex} initial={{
                opacity: 0,
                y: 20
              }} animate={{
                opacity: 1,
                y: 0
              }} exit={{
                opacity: 0,
                y: -20
              }} transition={{
                duration: 0.5
              }} data-id="element-129">
                  {rotatingWords[currentWordIndex]}
                </motion.span>
              </AnimatePresence>
            </motion.div>

            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            delay: 0.4,
            ease: 'easeOut'
          }} className="text-lg md:text-xl text-slate-700 mb-10 leading-relaxed" data-id="element-130">
              Acompañamos cada etapa con cercanía y compromiso, creando
              experiencias transformadoras. Nos aseguramos que cada encuentro
              tenga sentido tanto para el cliente como para el candidato.
            </motion.p>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            delay: 0.5,
            ease: 'easeOut'
          }} className="flex flex-col sm:flex-row gap-4" data-id="element-131">
              <motion.a href="#contacto" whileHover={{
              scale: 1.03
            }} whileTap={{
              scale: 0.98
            }} className="group inline-flex items-center justify-center px-8 py-4 bg-gradient-to-r from-purple-500 to-purple-600 text-white font-semibold rounded-xl shadow-lg shadow-purple-500/30 hover:shadow-xl hover:shadow-purple-500/40 transition-all duration-300" data-id="element-132">
                Busco talento
                <ArrowRightIcon className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-133" />
              </motion.a>

              <motion.a href="#empleo" whileHover={{
              scale: 1.03
            }} whileTap={{
              scale: 0.98
            }} className="inline-flex items-center justify-center px-8 py-4 bg-white text-slate-700 font-semibold rounded-xl border-2 border-slate-300 hover:border-purple-500 hover:text-purple-500 shadow-md hover:shadow-lg transition-all duration-300" data-id="element-134">
                Busco empleo
              </motion.a>
            </motion.div>
          </motion.div>

          {/* Right side - Image */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 0.3,
          ease: 'easeOut'
        }} className="relative h-[500px] lg:h-[600px] rounded-3xl overflow-hidden shadow-2xl" data-id="element-135">
            <img src="https://images.unsplash.com/photo-1543269865-cbf427effbad?w=1920&q=80" alt="Equipo diverso colaborando felizmente en ambiente laboral amigable" className="w-full h-full object-cover" data-id="element-136" />
            <div className="absolute inset-0 bg-gradient-to-br from-purple-500/10 to-emerald-500/10" data-id="element-137"></div>
          </motion.div>
        </div>
      </div>
    </section>;
}